<template>
    <!-- Wing Tab Navigation -->
    <div class="section pt-1 mt-2">
        <div class="wallet-card">
            <div class="wallet-footer">
                <ul class="nav nav-tabs lined" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '1' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('1')">
                            {{ $t('wisdom') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '2' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('2')">
                            {{ $t('youth') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '3' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('3')">
                            {{ $t('students') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '4' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('4')">
                            {{ $t('women') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: filters.wing === '6' }" data-bs-toggle="tab" 
                           href="javascript:void(0)" role="tab" @click="onWingChange('6')">
                            {{ $t('girls') }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Filter Section with Accordion -->
    <div class="section inset mt-1 mb-1" v-if="!loading">
        <div class="accordion" id="accordionExample2">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#accordion001" aria-expanded="false">
                        <ion-icon name="filter-outline" role="img" class="md hydrated"
                            aria-label="wallet outline"></ion-icon>
                        Filter
                    </button>
                </h2>
                <div id="accordion001" class="accordion-collapse collapse" :class="hasActiveFilters ? 'show' : ''"
                    data-bs-parent="#accordionExample2" style="">
                    <div class="accordion-body">
                        <div id="search" style="padding: 0px !important;">
                            <!-- District Filter (State Admins only) -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_district">{{ $t('district') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.district"
                                        name="filter_district" id="filter_district" @change="onDistrictChange">
                                        <option value>---Select District---</option>
                                        <option v-for="d in districtsList" v-bind:value="d.id" v-bind:key="d.id">{{ d.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Designation Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_position">{{ $t('designation') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.position"
                                        name="filter_position" id="select4">
                                        <option value>---All---</option>
                                        <option v-for="position in positionsList" v-bind:value="position.id" v-bind:key="position.id">{{
                                            position.value_mal || position.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Department Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_department">{{ $t('department') }}</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.department"
                                        name="filter_department" id="select5" @change="onDepartmentChange">
                                        <option value>---All---</option>
                                        <option v-for="department in departmentsList" v-bind:value="department.id" v-bind:key="department.id">{{
                                            department.name_mal || department.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="clearFilters()">
                                        <ion-icon name="trash-bin-outline" role="img" class="md hydrated"
                                            aria-label="add outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="applyFilters()">
                                        <ion-icon name="search-outline" role="img" class="md hydrated"
                                            aria-label="add outline"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Search Box -->
    <div id="search">
        <form class="search-form">
            <div class="form-group searchbox">
                <input type="text" class="form-control" :placeholder="$t('search')" v-model="searchQuery"
                    @input="filteredExecutives()">
                <i class="input-icon">
                    <ion-icon name="search-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>

    <!-- Loading -->
    <div class="section text-center mt-2" v-if="loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <!-- Summary Stats -->
    <div class="section" v-if="!loading && hierarchicalData.length > 0 && showTotalExecutivesCard">
        <div class="row mt-1">
            <div class="col-12">
                <div class="stat-box">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <div class="title mal-text text-primary">{{ $t('total_executives') }}</div>
                            <div class="value text-dark"><span class="text-primary">{{ totalExecutives }}</span></div>
                        </div>
                        <button type="button" class="btn btn-success btn-sm" @click="shareViaWhatsApp" 
                                v-if="totalExecutives > 0">
                            <ion-icon name="logo-whatsapp"></ion-icon>
                            Share
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Share Button for Zone Admins (when total card is hidden) -->
    <div class="section" v-if="!loading && hierarchicalData.length > 0 && !showTotalExecutivesCard">
        <div class="row mt-1">
            <div class="col-12">
                <button type="button" class="btn btn-success btn-sm w-100" @click="shareViaWhatsApp" 
                        v-if="totalExecutives > 0">
                    <ion-icon name="logo-whatsapp"></ion-icon>
                    Share List ({{ totalExecutives }} {{ $t('executives') }})
                </button>
            </div>
        </div>
    </div>

    <!-- District-grouped list (same as zone/unit: each district section with its executives) -->
    <div v-for="zone in hierarchicalData" :key="zone.id" class="zone-section">
        <!-- District Header -->
        <div class="zone-header">
            <div class="listview-title mt-1 mb-1 mal-text text-primary" style="font-size: 15px; font-weight: bold;">
                {{ zone.name }} ({{ zone.executives.length }} {{ $t('executives') }})
            </div>
        </div>
        
        <!-- Executives List for this District -->
        <ul class="listview image-listview inset text mt-0 mb-1" v-if="zone.executives.length > 0">
            <li v-for="(executive, index) in zone.executives" :key="executive.id">
                <a href="javascript:void(0)" class="item">
                    <span class="sl-no">{{ index + 1 }}</span>
                    <div class="avatar-section">
                        <a href="#">
                            <img v-if="executive.member && executive.member.avatar && executive.member.avatar !== 'member.jpg'" 
                                 :src="'https://guide.msoftit.com/' + executive.member.avatar" 
                                 alt="avatar" class="image">
                            <img v-else 
                                 src="assets/img/sample/avatar/avatar1.png" 
                                 alt="avatar" class="image">
                        </a>
                    </div>
                    <div class="in">
                        <div class="min-width-50">
                            <b>{{ executive.member ? executive.member.name : 'N/A' }}</b>
                            <footer>
                                <!-- Contact Information -->
                                <template v-if="shouldShowContactInfo(executive)">
                                    <span v-if="executive.member && executive.member.mobile">
                                        {{ executive.member.country_code }} {{ executive.member.mobile }}
                                    </span>
                                    <span v-if="executive.member && executive.member.whatsapp_number">
                                        <br>WhatsApp: {{ executive.member.whatsapp_country_code || executive.member.country_code }} {{ executive.member.whatsapp_number }}
                                    </span>
                                    <br v-if="executive.user_sublevel_desc && (executive.member?.mobile || executive.member?.whatsapp_number)">
                                </template>
                                
                                <!-- Designation -->
                                <span v-if="executive.user_sublevel_desc || executive.designation">
                                    <strong class="text-primary">{{ 
                                        ((executive.designation && executive.designation.toLowerCase().includes('state councillor')) || 
                                         (executive.user_sublevel_desc && executive.user_sublevel_desc.toLowerCase().includes('state councillor'))) 
                                            ? (executive.comments && executive.comments.trim() ? executive.comments.trim() : 'State Councillor')
                                            : (executive.user_sublevel_desc || executive.designation)
                                    }}</strong>
                                </span>
                                
                                <!-- Departments -->
                                <span v-if="executive.departments && executive.departments.length > 0">
                                    <br v-if="executive.user_sublevel_desc || (shouldShowContactInfo(executive) && (executive.member?.mobile || executive.member?.whatsapp_number))"><em class="text-muted">
                                        <span v-for="(dept, deptIndex) in executive.departments" :key="dept.id">
                                            {{ dept.name_mal || dept.name }}<span v-if="deptIndex < executive.departments.length - 1">, </span>
                                        </span>
                                    </em>
                                </span>
                            </footer>
                        </div>
                        
                        <!-- Action Button - Only show for Women's and Girls' wing members -->
                        <div class="card-button dropdown" v-if="canShowActionModal">
                            <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                                :data-bs-target="'#actionSheetInset'+executive.id">
                                <ion-icon name="ellipsis-horizontal"></ion-icon>
                            </button>
                        </div>
                    </div>
                </a>
                
                <!-- Action Sheet Modal - Only render for Women's and Girls' wing members -->
                <div class="modal fade action-sheet" :id="'actionSheetInset'+executive.id" tabindex="-1" role="dialog" v-if="canShowActionModal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Action</h5>
                            </div>
                            <div class="modal-body">
                                <ul class="action-button-list">
                                    <li v-if="executive.member && executive.member.mobile">
                                        <a :href="'tel:' + (executive.member.country_code || '+91') + executive.member.mobile" class="btn btn-list">
                                            <span>
                                                <ion-icon name="call-outline"></ion-icon> Call
                                            </span>
                                        </a>
                                    </li>
                                    <li v-if="executive.member && (executive.member.whatsapp_number || executive.member.mobile)">
                                        <a :href="'https://wa.me/' + (executive.member.whatsapp_country_code || executive.member.country_code || '91') + (executive.member.whatsapp_number || executive.member.mobile) + '?text='" 
                                           class="btn btn-list">
                                            <span>
                                                <ion-icon name="logo-whatsapp"></ion-icon> WhatsApp
                                            </span>
                                        </a>
                                    </li>
                                    <li class="action-divider"></li>
                                    <li>
                                        <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="close-outline"></ion-icon> Cancel
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        
        <!-- No executives in this district -->
        <div v-if="zone.executives.length === 0" class="text-center p-2 text-muted">
            <em>{{ $t('no_executives_in_district') || $t('no_executives_in_zone') }}</em>
        </div>
        
        <!-- District Separator (except for last) -->
        <div v-if="hierarchicalData.indexOf(zone) < hierarchicalData.length - 1" class="zone-bottom-separator"></div>
    </div>

    <!-- No Data Message -->
    <div v-if="!loading && hierarchicalData.length === 0" class="text-center p-4">
        <p class="text-muted">{{ $t('no_executives_found') }}</p>
    </div>

    <!-- Pagination Component -->
    <div class="section mt-2" v-if="!loading && !executivesLoading && executivesData && executivesData.total > 0">
        <vue-awesome-paginate 
            v-if="executivesData.total > executivesData.per_page"
            :total-items="executivesData.total" 
            :items-per-page="executivesData.per_page"
            :max-pages-shown="3" 
            v-model="executivesData.current_page" 
            :on-click="onPaginationClick"
            :show-ending-buttons="true" 
            :show-breakpoint-buttons="false" />
    </div>
</template>

<script>
import UserService from "../../services/user.service";
import { mapState } from "vuex";

export default {
    name: "DistrictExecutiveList",
    
    data() {
        return {
            loading: false,
            hierarchicalData: [],
            originalHierarchicalData: [],
            originalExecutivesData: [],
            totalExecutives: 0,
            searchQuery: '',
            
            // Pagination data
            executivesData: {
                data: [],
                total: 0,
                per_page: 20,
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0
            },
            executivesLoading: false,
            allComprehensiveData: [],
            isClientSidePagination: false,
            
            // Filter data
            filters: {
                wing: '',
                district: '',
                position: '',
                department: ''
            },
            
            // Dropdown lists
            districtsList: [],
            positionsList: [
                { id: '1', value: 'President', value_mal: 'പ്രസിഡന്റ്' },
                { id: '2', value: 'Vice President', value_mal: 'വൈസ് പ്രസിഡന്റ്' },
                { id: '3', value: 'General Secretary', value_mal: 'ജനറൽ സെക്രെട്ടറി' },
                { id: '4', value: 'Joint Secretary', value_mal: 'ജോയിന്റ് സെക്രെട്ടറി' },
                { id: '5', value: 'Treasurer', value_mal: 'ട്രഷറർ' },
                { id: '6', value: 'Executive Member', value_mal: 'എക്സിक्यൂട്ടീവ് മെമ്പർ' },
            ],
            departmentsList: [],
        };
    },

    computed: {
        ...mapState({
            currentUser: state => state.auth.user
        }),
        
        hasActiveFilters() {
            return this.filters.district || this.filters.position || this.filters.department;
        },
        
        filterCount() {
            let count = 0;
            if (this.filters.district) count++;
            if (this.filters.position) count++;
            if (this.filters.department) count++;
            return count;
        },
        
        isStateAdmin() {
            return this.currentUser && parseInt(this.currentUser.user_level) === 1;
        },
        
        showTotalExecutivesCard() {
            return this.isStateAdmin;
        },
        
        canShowActionModal() {
            // Show 3-dot modal based on user's wing and current viewing wing
            if (!this.currentUser) {
                return false;
            }
            
            const userWing = this.currentUser.wing;
            const currentViewingWing = this.filters.wing;
            
            // Women's (4) and Girls' (6) members: can see 3-dot buttons on ALL wings
            if (userWing === 4 || userWing === 6) {
                return true;
            }
            
            // Org (1), Youth (2), Students (3) members: can see 3-dot buttons on Org, Youth, and Students wings only
            if (userWing === 1 || userWing === 2 || userWing === 3) {
                return currentViewingWing === '1' || currentViewingWing === '2' || currentViewingWing === '3';
            }
            
            return false;
        },
        
        shouldShowContactInfo() {
            return (executive) => {
                if (!this.currentUser) {
                    return false;
                }
                
                const userWing = this.currentUser.wing;
                const executiveWing = executive.wing_id || executive.wing || executive.wing_type;
                
                // Org (1), Youth (2), Students (3) members: cannot see Women's (4) and Girls' (6) contact info
                if (userWing === 1 || userWing === 2 || userWing === 3) {
                    return executiveWing !== 4 && executiveWing !== '4' && executiveWing !== 6 && executiveWing !== '6';
                }
                
                // Women's (4) and Girls' (6) members: can see all contact info
                if (userWing === 4 || userWing === 6) {
                    return true;
                }
                
                return true;
            };
        }
    },

    watch: {
        '$route'(to, from) {
            if (to.path !== from.path) {
                this.districtsList = [];
                this.loadExecutivesList(1);
            }
        }
    },

    mounted() {
        if (!this.currentUser) {
            location.replace('/');
            return;
        }
        if (parseInt(this.currentUser.user_level) !== 1) {
            location.replace('/');
            return;
        }
        this.filters.wing = '1';
        this.initializeComponent();
        this.$root.updateParent(this.$t('district_level_executives'));
    },

    methods: {
        initializeComponent() {
            this.loadInitialData();
            // Load list: all districts when none selected, or filtered by district when selected
            this.loadExecutivesList(1);
        },

        async loadInitialData() {
            try {
                await this.loadDistrictsList();
                await this.loadDepartmentsList();
            } catch (error) {
                // Silent error handling
            }
        },

        async loadDistrictsList() {
            try {
                const response = await UserService.authPostRequest('get-district-by-id', {});
                if (response.data.status === 'success' && response.data.data) {
                    const list = response.data.data.list;
                    this.districtsList = Array.isArray(list) ? list : (list && typeof list === 'object' ? [list] : []);
                } else {
                    this.districtsList = [];
                }
            } catch (error) {
                this.districtsList = [];
            }
        },

        async loadDepartmentsList() {
            try {
                const data = {
                    wing: this.filters.wing || '1',
                    user_level: 2,
                    level_id: this.filters.district || this.currentUser.district_id
                };
                const response = await UserService.authPostRequest('get-departments', data);
                if (response.data.status === 'success' && response.data.data && response.data.data.list) {
                    this.departmentsList = response.data.data.list || [];
                } else {
                    this.departmentsList = [];
                }
            } catch (error) {
                this.departmentsList = [];
            }
        },

        async getUserLocationNames() {
            // Get location names for display purposes if not already available
            if (!this.currentUser.district_name && this.currentUser.district_id) {
                try {
                    const response = await UserService.authPostRequest('get-district-by-id', {});
                    if (response.data.status === 'success') {
                        const districts = response.data.data.list || [];
                        const currentDistrict = districts.find(d => d.id == this.currentUser.district_id);
                        if (currentDistrict) {
                            this.currentUser.district_name = currentDistrict.name;
                        }
                    }
                } catch (error) {
                    // Silent error handling
                }
            }
            
            if (!this.currentUser.zone_name && this.currentUser.zone_id) {
                try {
                    const response = await UserService.authPostRequest('get-zone-by-id', {
                        district_id: this.currentUser.district_id
                    });
                    if (response.data.status === 'success') {
                        const zones = response.data.data.list || [];
                        const currentZone = zones.find(z => z.id == this.currentUser.zone_id);
                        if (currentZone) {
                            this.currentUser.zone_name = currentZone.name;
                        }
                    }
                } catch (error) {
                    // Silent error handling
                }
            }
        },

        async loadExecutivesList(page = 1) {
            this.executivesLoading = true;
            this.loading = true;
            try {
                const executiveParams = {
                    wing: this.filters.wing || '1',
                    term: 2,
                    page,
                    limit: 10000,
                    request_source: 'DistrictExecutiveList_' + Date.now()
                };
                if (this.filters.district) {
                    executiveParams.district_id = this.filters.district;
                }
                if (this.filters.position) {
                    const pos = this.positionsList.find(p => p.id === this.filters.position || p.value === this.filters.position);
                    executiveParams.designation = pos ? pos.value : this.filters.position;
                }
                // Department filter is applied client-side so it works even if API does not filter by department_id
                // if (this.filters.department) { executiveParams.department_id = this.filters.department; }

                const response = await UserService.authPostRequest('get-district-executives-data', executiveParams);

                if (response && response.data && (response.data.success || response.data.status === 'success')) {
                    const isComprehensiveView = true;
                    
                    // Handle paginated response structure
                    if (response.data.data && typeof response.data.data === 'object' && response.data.data.data) {
                        const responseData = response.data.data.data || [];
                        
                        if (isComprehensiveView) {
                            const defaultPerPage = 20;
                            this.allComprehensiveData = responseData;
                            this.isClientSidePagination = true;
                            
                            const firstPageData = responseData.slice(0, defaultPerPage);
                            this.executivesData = {
                                data: firstPageData,
                                total: responseData.length,
                                per_page: defaultPerPage,
                                current_page: 1,
                                last_page: Math.ceil(responseData.length / defaultPerPage),
                                from: 1,
                                to: Math.min(defaultPerPage, responseData.length)
                            };
                        } else {
                            this.allComprehensiveData = [];
                            this.isClientSidePagination = false;
                            
                            this.executivesData = {
                                data: responseData,
                                total: response.data.data.total || 0,
                                per_page: response.data.data.per_page || 20,
                                current_page: response.data.data.current_page || 1,
                                last_page: response.data.data.last_page || 1,
                                from: response.data.data.from || 0,
                                to: response.data.data.to || 0
                            };
                        }
                    } else {
                        // Simple array response
                        const allData = Array.isArray(response.data.data) ? response.data.data : (response.data.data?.list || []);
                        
                        if (isComprehensiveView) {
                            this.executivesData = {
                                data: allData,
                                total: allData.length,
                                per_page: allData.length,
                                current_page: 1,
                                last_page: 1,
                                from: 1,
                                to: allData.length
                            };
                        } else {
                            const perPage = 20;
                            const totalItems = response.data.total || allData.length;
                            const totalPages = Math.ceil(totalItems / perPage);
                            const startIndex = (page - 1) * perPage;
                            const endIndex = startIndex + perPage;
                            const pageData = allData.slice(startIndex, endIndex);
                            
                            this.executivesData = {
                                data: pageData,
                                total: totalItems,
                                per_page: perPage,
                                current_page: page,
                                last_page: totalPages,
                                from: startIndex + 1,
                                to: Math.min(endIndex, totalItems)
                            };
                        }
                    }
                    
                    // Client-side wing filtering
                    const expectedWingFilter = this.filters.wing || '1';
                    const wingFilteredData = this.executivesData.data.filter(executive => {
                        const executiveWing = executive.wing_id || executive.wing || executive.wing_type || '1';
                        return executiveWing.toString() === expectedWingFilter;
                    });
                    
                    if (wingFilteredData.length !== this.executivesData.data.length) {
                        this.executivesData.data = wingFilteredData;
                        this.executivesData.total = wingFilteredData.length;
                        this.executivesData.to = wingFilteredData.length;
                    }
                    
                    // Filter out regular "Member" entries - only show Executive Members
                    const executiveOnlyData = this.filterExecutiveMembersOnly(this.executivesData.data);
                    
                    if (executiveOnlyData.length !== this.executivesData.data.length) {
                        this.executivesData.data = executiveOnlyData;
                        this.executivesData.total = executiveOnlyData.length;
                        this.executivesData.to = executiveOnlyData.length;
                    }
                    
                    // Exact designation filter: when "Secretary" is selected, show only Secretary (not Joint Secretary, etc.)
                    if (this.filters.position) {
                        const pos = this.positionsList.find(p => p.id === this.filters.position || p.value === this.filters.position);
                        const selectedDesignation = (pos && pos.value) ? pos.value.trim() : (this.filters.position && typeof this.filters.position === 'string' ? this.filters.position.trim() : '');
                        if (selectedDesignation) {
                            const designationExactMatch = this.executivesData.data.filter(executive => {
                                const execDesignation = (executive.designation || executive.user_sublevel_desc || '').trim();
                                return execDesignation === selectedDesignation;
                            });
                            if (designationExactMatch.length !== this.executivesData.data.length) {
                                this.executivesData.data = designationExactMatch;
                                this.executivesData.total = designationExactMatch.length;
                                this.executivesData.to = designationExactMatch.length;
                            }
                        }
                    }
                    
                    // Department filter: show only executives in the selected department (flexible name match)
                    if (this.filters.department) {
                        const selectedDepartment = this.departmentsList.find(dept => dept.id == this.filters.department);
                        if (selectedDepartment) {
                            const norm = (s) => {
                                if (s == null || s === '') return '';
                                return String(s).trim().toLowerCase()
                                    .replace(/\s*&\s*/g, ' and ')
                                    .replace(/\s+/g, ' ');
                            };
                            const selectedNorm = norm(selectedDepartment.name || '');
                            const selectedMalNorm = norm(selectedDepartment.name_mal || '');
                            const departmentExactMatch = this.executivesData.data.filter(executive => {
                                const departments = executive.departments || '';
                                if (!departments) return false;
                                // Match by id if executive has department objects with id
                                if (Array.isArray(departments) && departments.some(d => d && (d.id == this.filters.department || (d.id != null && String(d.id) === String(this.filters.department))))) {
                                    return true;
                                }
                                let departmentArray = [];
                                if (typeof departments === 'string') {
                                    const parts = departments.split(',').map(d => d.trim()).filter(d => d && d !== 'None' && d !== 'none');
                                    departmentArray = parts.map(p => norm(p));
                                    if (norm(departments) !== '' && !departmentArray.includes(norm(departments))) {
                                        departmentArray.push(norm(departments));
                                    }
                                } else if (Array.isArray(departments)) {
                                    departmentArray = departments.map(dept => {
                                        const name = typeof dept === 'string' ? dept : (dept.name || dept.name_mal || '');
                                        return norm(name || '');
                                    }).filter(d => d);
                                }
                                if (!selectedNorm && !selectedMalNorm) return false;
                                return departmentArray.some(dept =>
                                    dept === selectedNorm || dept === selectedMalNorm
                                );
                            });
                            if (departmentExactMatch.length !== this.executivesData.data.length) {
                                this.executivesData.data = departmentExactMatch;
                                this.executivesData.total = departmentExactMatch.length;
                                this.executivesData.to = departmentExactMatch.length;
                            }
                        }
                    }
                    
                    // Single district list (no zone grouping)
                    this.hierarchicalData = this.buildDistrictGroupedByDistrict(this.executivesData.data);
                    this.originalHierarchicalData = [...this.hierarchicalData];
                    this.totalExecutives = this.executivesData.total;
                    this.originalExecutivesData = [...this.executivesData.data];
                    this.populateFilterDropdownsFromData(this.executivesData.data);
                } else {
                    // No data found
                    this.executivesData = {
                        data: [],
                        total: 0,
                        per_page: 20,
                        current_page: 1,
                        last_page: 1,
                        from: 0,
                        to: 0
                    };
                    this.hierarchicalData = [];
                    this.totalExecutives = 0;
                }
                
            } catch (error) {
                this.executivesData = {
                    data: [],
                    total: 0,
                    per_page: 20,
                    current_page: 1,
                    last_page: 1,
                    from: 0,
                    to: 0
                };
                this.hierarchicalData = [];
                this.totalExecutives = 0;
            } finally {
                this.executivesLoading = false;
                this.loading = false;
            }
        },

        populateFilterDropdownsFromData(executiveData) {
            if (!executiveData || !Array.isArray(executiveData) || executiveData.length === 0) {
                return;
            }
            // Extract unique designations from executive data for filter dropdown
            const uniquePositions = [];
            const positionTexts = new Set();
            let positionIdCounter = 1;
            executiveData.forEach(executive => {
                const designation = executive.designation || executive.user_sublevel_desc || '';
                if (designation && !positionTexts.has(designation)) {
                    uniquePositions.push({
                        id: positionIdCounter.toString(),
                        value: designation,
                        value_mal: designation
                    });
                    positionTexts.add(designation);
                    positionIdCounter++;
                }
            });
            this.positionsList = uniquePositions.sort((a, b) => (a.value || '').localeCompare(b.value || ''));
        },

        // Helper function to filter out regular "Member" entries - only show Executive Members
        filterExecutiveMembersOnly(executives) {
            if (!executives || !Array.isArray(executives)) {
                return [];
            }
            
            return executives.filter(executive => {
                const designation = (executive.designation || executive.user_sublevel_desc || '').toLowerCase().trim();
                
                // Exclude entries that are just "Member" or "മെമ്പർ" (Member in Malayalam)
                // But include "Executive Member", "എക്സിക്യൂട്ടീവ് മെമ്പർ", and other executive designations
                if (!designation) {
                    return false; // Exclude entries with no designation
                }
                
                // Exclude if designation is exactly "member" or "മെമ്പർ"
                if (designation === 'member' || designation === 'മെമ്പർ') {
                    return false;
                }
                
                // Include all other designations (Executive Member, President, etc.)
                return true;
            });
        },

        /** Map API executive row to view shape (member object, departments array) */
        apiToViewShape(executive) {
            if (!executive) return null;
            const deptStr = executive.departments;
            const departments = !deptStr || deptStr === 'None'
                ? []
                : (Array.isArray(deptStr) ? deptStr : deptStr.split(', ').map(name => ({ name: name.trim() })).filter(d => d.name));
            return {
                id: executive.id,
                wing: executive.wing,
                wing_name: executive.wing_name,
                designation: executive.designation,
                user_sublevel_desc: executive.user_sublevel_desc || executive.designation,
                user_sublevel: executive.user_sublevel,
                comments: executive.comments || '',
                departments,
                member: {
                    name: executive.member_name,
                    mobile: executive.member_phone ? executive.member_phone.replace(/\+\d+\s*/, '').trim() : '',
                    country_code: executive.member_phone && String(executive.member_phone).startsWith('+91') ? '+91' : '+91',
                    whatsapp_number: executive.member_phone ? executive.member_phone.replace(/\+\d+\s*/, '').trim() : '',
                    whatsapp_country_code: executive.member_phone && String(executive.member_phone).startsWith('+91') ? '+91' : '+91',
                    avatar: executive.avatar || null
                },
                district_name: executive.district_name,
                zone_name: executive.zone_name,
                created_at: executive.created_at,
                updated_at: executive.updated_at
            };
        },

        /** Build list grouped by district (same pattern as zone/unit listing). Each district shows its executives. */
        buildDistrictGroupedByDistrict(flatData) {
            if (!flatData || !Array.isArray(flatData) || flatData.length === 0) {
                return [];
            }
            const byDistrict = new Map();
            flatData.forEach((exec) => {
                const districtId = exec.district_id || 0;
                const districtName = exec.district_name || this.$t('unknown_district') || 'Unknown District';
                const key = districtId;
                if (!byDistrict.has(key)) {
                    byDistrict.set(key, { id: districtId, name: districtName, executives: [] });
                }
                const viewShape = this.apiToViewShape(exec);
                if (viewShape) byDistrict.get(key).executives.push(viewShape);
            });
            const result = Array.from(byDistrict.values());
            result.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            return result;
        },

        calculateTotalExecutives() {
            let total = 0;
            this.hierarchicalData.forEach(zone => {
                total += zone.executives.length;
            });
            return total;
        },

        // Search functionality
        filteredExecutives() {
            if (!this.searchQuery.trim()) {
                this.hierarchicalData = [...this.originalHierarchicalData];
                this.totalExecutives = this.calculateTotalExecutives();
                return;
            }

            const searchLower = this.searchQuery.toLowerCase();
            
            // Filter the original flat data first
            let filteredFlatData = this.originalExecutivesData.filter(executive => {
                const memberName = executive.member_name?.toLowerCase() || '';
                const mobile = executive.member_phone?.toLowerCase() || '';
                const designation = executive.designation?.toLowerCase() || '';
                const zoneName = executive.zone_name?.toLowerCase() || '';
                const districtName = executive.district_name?.toLowerCase() || '';
                
                return memberName.includes(searchLower) ||
                       mobile.includes(searchLower) ||
                       designation.includes(searchLower) ||
                       zoneName.includes(searchLower) ||
                       districtName.includes(searchLower);
            });
            
            // Filter out regular "Member" entries - only show Executive Members
            filteredFlatData = this.filterExecutiveMembersOnly(filteredFlatData);
            
            // Group by district (same as zone/unit listing)
            this.hierarchicalData = this.buildDistrictGroupedByDistrict(filteredFlatData);
            this.totalExecutives = filteredFlatData.length;
        },

        // Filter event handlers
        onWingChange(wing) {
            this.filters.wing = wing;
            this.filters.department = '';
            
            // Clear existing data immediately
            this.executivesData = {
                data: [],
                total: 0,
                per_page: 10,
                current_page: 1,
                from: 0,
                to: 0
            };
            this.hierarchicalData = [];
            this.originalExecutivesData = [];
            this.totalExecutives = 0;
            
            this.loading = true;
            this.executivesLoading = true;
            
            this.loadDepartmentsList();
            this.loadExecutivesList(1);
        },

        onDistrictChange() {
            this.filters.department = '';
            this.filters.position = '';
            this.loadDepartmentsList();
            this.loadExecutivesList(1);
        },

        onDepartmentChange() {
            // Don't apply filters automatically - wait for user to click Filter button
        },

        applyFilters() {
            this.loadExecutivesList(1);
        },

        clearFilters() {
            this.filters = {
                wing: '1',
                district: '',
                position: '',
                department: ''
            };
            this.searchQuery = '';
            this.executivesData = { data: [], total: 0, per_page: 20, current_page: 1, last_page: 1, from: 0, to: 0 };
            this.hierarchicalData = [];
            this.totalExecutives = 0;
            this.originalExecutivesData = [];
        },

        // Pagination methods
        onPaginationClick(page) {
            if (this.isClientSidePagination && this.allComprehensiveData.length > 0) {
                // Handle client-side pagination
                const perPage = this.executivesData.per_page;
                const startIndex = (page - 1) * perPage;
                const endIndex = startIndex + perPage;
                const pageData = this.allComprehensiveData.slice(startIndex, endIndex);
                
                this.executivesData = {
                    ...this.executivesData,
                    data: pageData,
                    current_page: page,
                    from: startIndex + 1,
                    to: Math.min(endIndex, this.allComprehensiveData.length)
                };
                
                this.hierarchicalData = this.buildDistrictGroupedByDistrict(pageData);
            } else {
                // Handle server-side pagination
                this.loadExecutivesList(page);
            }
        },

        refreshExecutives() {
            this.loadExecutivesList(1);
        },

        shareViaWhatsApp() {
            try {
                // Get current wing name
                const wingName = this.getWingName(this.filters.wing || '1');
                
                // Build the share text
                let shareText = `*${this.$t('district_level_executives')} - ${wingName}*\n\n`;
                
                // Add filter information if any filters are active
                const activeFilters = [];
                if (this.filters.district) {
                    const selectedDistrict = this.districtsList.find(d => d.id == this.filters.district);
                    if (selectedDistrict) {
                        activeFilters.push(`District: ${selectedDistrict.name}`);
                    }
                }
                if (this.filters.position) {
                    const selectedPosition = this.positionsList.find(pos => pos.id === this.filters.position);
                    if (selectedPosition) {
                        activeFilters.push(`Designation: ${selectedPosition.value_mal || selectedPosition.value}`);
                    }
                }
                if (this.filters.department) {
                    const selectedDepartment = this.departmentsList.find(dept => dept.id == this.filters.department);
                    if (selectedDepartment) {
                        activeFilters.push(`Department: ${selectedDepartment.name_mal || selectedDepartment.name}`);
                    }
                }
                
                if (activeFilters.length > 0) {
                    shareText += `*Filters:* ${activeFilters.join(', ')}\n\n`;
                }
                
                shareText += `*Total: ${this.totalExecutives} ${this.$t('executives')}*\n\n`;
                shareText += `━━━━━━━━━━━━━━━━━━━━\n\n`;
                
                // Add executive details
                let executiveCount = 0;
                this.hierarchicalData.forEach((zone, zoneIndex) => {
                    if (zoneIndex > 0) {
                        shareText += `\n`;
                    }
                    
                    shareText += `*${zone.name}*\n\n`;
                    
                    zone.executives.forEach((executive) => {
                        executiveCount++;
                        shareText += `${executiveCount}. *${executive.member ? executive.member.name : 'N/A'}*\n`;
                        
                        // Add designation
                        if (executive.user_sublevel_desc) {
                            shareText += `   ${executive.user_sublevel_desc}\n`;
                        }
                        
                        // Add contact info if visible
                        if (this.shouldShowContactInfo(executive)) {
                            if (executive.member && executive.member.mobile) {
                                shareText += `   📞 ${executive.member.country_code} ${executive.member.mobile}\n`;
                            }
                            if (executive.member && executive.member.whatsapp_number) {
                                shareText += `   💬 WhatsApp: ${executive.member.whatsapp_country_code || executive.member.country_code} ${executive.member.whatsapp_number}\n`;
                            }
                        }
                        
                        // Add departments
                        if (executive.departments && executive.departments.length > 0) {
                            const deptNames = executive.departments.map(dept => dept.name_mal || dept.name).join(', ');
                            shareText += `   📋 ${deptNames}\n`;
                        }
                        
                        shareText += `\n`;
                    });
                });
                
                shareText += `━━━━━━━━━━━━━━━━━━━━\n`;
                shareText += `*Generated from Wisdom Guide App*\n`;
                
                // Encode the text for URL
                const encodedText = encodeURIComponent(shareText);
                
                // Create WhatsApp share URL
                const whatsappUrl = `https://wa.me/?text=${encodedText}`;
                
                // Open WhatsApp in new window/tab
                window.open(whatsappUrl, '_blank');
                
            } catch (error) {
                console.error('Error sharing via WhatsApp:', error);
                alert('Failed to share. Please try again.');
            }
        },

        getWingName(wing) {
            const wingNames = {
                '1': this.$t('wisdom'),
                '2': this.$t('youth'),
                '3': this.$t('students'),
                '4': this.$t('women'),
                '5': this.$t('balavedi'),
                '6': this.$t('girls')
            };
            return wingNames[wing] || 'Unknown';
        }
    }
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
    font-size: 12px;
    line-height: 1.3;
    padding-top: 2px;
    margin-top: 2px;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 700;
    margin-right: 8px;
    font-size: 13px;
    min-width: 20px;
}

.image-listview.text>li:after {
    left: 0px;
    background-color: #1a418c;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.avatar-section .abroad {
    background: #0962d2;
}

.avatar-section .payment-verified {
    background: #05d0a4;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    padding: 10px 10px;
}

.stat-box .btn-success {
    background-color: #25D366;
    border-color: #25D366;
    color: white;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 6px;
}

.stat-box .btn-success:hover {
    background-color: #20BA5A;
    border-color: #20BA5A;
    color: white;
}

.stat-box .btn-success ion-icon {
    font-size: 18px;
}

/* Tab Navigation Styling */
.nav-link.active {
    background-color: #007bff;
    color: white;
}

.action .btn-sm {
    height: auto;
    width: auto;
    margin-right: 5px;
}

/* Zone Separators - Compact */
.zone-section {
    margin-bottom: 10px;
}

.zone-header {
    position: relative;
    padding: 0 8px;
}

.zone-bottom-separator {
    height: 1px;
    background: #e9ecef;
    margin: 10px 0;
    border-radius: 1px;
}

/* Enhanced listview styling - Compact */
.zone-section .listview {
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0,0,0,0.08);
    margin-bottom: 4px;
}

.zone-section .listview li:first-child .item {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.zone-section .listview li:last-child .item {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

/* Reduce padding in list items */
.zone-section .listview .item {
    padding: 8px 12px;
    min-height: auto;
}

.zone-section .listview .item .in {
    padding-left: 8px;
}

/* Compact avatar sizing */
.zone-section .avatar-section .image {
    width: 38px;
    height: 38px;
}

/* Mobile-specific optimizations */
@media (max-width: 768px) {
    .zone-section {
        margin-bottom: 8px;
    }
    
    .zone-header .listview-title {
        font-size: 14px !important;
        margin-top: 6px !important;
        margin-bottom: 4px !important;
        padding: 0 4px;
    }
    
    .zone-section .listview .item {
        padding: 6px 10px;
    }
    
    .zone-section .listview .item .in {
        padding-left: 6px;
    }
    
    .zone-section .avatar-section .image {
        width: 34px;
        height: 34px;
    }
    
    .listview>li footer {
        font-size: 11px;
        line-height: 1.2;
        padding-top: 1px;
    }
    
    .min-width-50 {
        min-width: 55% !important;
    }
    
    .sl-no {
        font-size: 12px;
        margin-right: 6px;
    }
}

@media print {
    .section:first-child, .action, #search {
        display: none !important;
    }
    
    .listview>li {
        break-inside: avoid;
        page-break-inside: avoid;
    }
    
    .zone-section {
        break-inside: avoid;
        page-break-inside: avoid;
    }
}
</style>

